import facebookLogo from "./facebook-logo.svg";
import googleLogo from "./google-logo.svg";
import twitterLogo from "./twitter-logo.svg";

export type SocialProviderKey = "google" | "twitter" | "facebook";

export const SOCIAL_PROVIDERS = [
  {
    key: "google",
    logo: googleLogo,
    translationKey:
      "authentication_app.new_onboarding_flow_april_2025.signup_options.google",
  },
  {
    key: "twitter",
    logo: twitterLogo,
    translationKey:
      "authentication_app.new_onboarding_flow_april_2025.signup_options.twitter",
  },
  {
    key: "facebook",
    logo: facebookLogo,
    translationKey:
      "authentication_app.new_onboarding_flow_april_2025.signup_options.facebook",
  },
] as const;

export function getSocialProviders({
  googleEnabled,
}: {
  googleEnabled: boolean;
}) {
  return SOCIAL_PROVIDERS.filter(p => p.key !== "google" || googleEnabled);
}
